import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-unauthorized-user',
  templateUrl: './unauthorized-user.component.html',
  styleUrls: ['./unauthorized-user.component.css']
})
export class UnauthorizedUserComponent implements OnInit {

  constructor( private translate: TranslateService,) { }

  ngOnInit() {
  }

}
